<ng-container *ngIf="componentData$ | async as data">
  <cx-generic-link
    *ngIf="data.url !== '/bike/nl/nl/login'; else seuLogin"
    [ngClass]="getClass(styleClass, data.url)"
    [url]="data.url"
    [style]="data.styleAttributes"
    (click)="handleClick(data.url, $event)"
    >{{ data.linkName }}</cx-generic-link
  >

  <ng-template #seuLogin>
    <a role="link" [href]="data.url">{{ data.linkName }}</a>
  </ng-template>
</ng-container>
